/* Component Dependencies */
var $ = require('jquery');
var templateUnsuccessfulSellOverlay = require('templates/unsuccessfulSellOverlay.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');
var Popup = require('libs/popup');

PubSub.register(AriesComponent.extend({
  type: 'unsuccessfulSellOverlay',
  template: {
    'unsuccessfulSellOverlay': templateUnsuccessfulSellOverlay
  },
  unBindEvents: function($) {
    $('*[data-component-id="' + this.$el.data('component-id') + '"]').off();
    $('*[data-component-id="' + this.$el.data('component-id') + '"] *').off();
  },


  /**
  * This function is used to initiate methods on load
  */
  
  bindEvents: function() {
    this.showPopup();
    var _self = this;
    _self.$el.find('.nearby-hotels-resorts').on('click', function(e) {
      _self.pubsub.publish('POPUP_CLOSE');
    });

    if (_self.$el.find('.js-unsuccessful-sell-popover').length) {

      var mainClass = 'm-modal t-modal-small';
      if(_self.$el.find('.js-unsuccessful-forceSellLink').length){
        mainClass = 'm-modal t-modal-force-sell m-unsuccessful-sell-associate';
      }
      /**
      * This function is used to open unSuccessful Sell Overlay Popup
      */
      var unsuccessfullPopup = new Popup({
        open: true,
        items: {
          src: '.modal-content',
          type: 'inline'
        },
        sourceBlock: '.modal-content',
        alternateCloseMarkup: true,
        mainClass: mainClass
      });
      unsuccessfullPopup.register();
    }
  },
  /**
  * This function is used to open Popup
  * @param {Object} event Mouse event triggered on Force Sell icon click.
  */
  showPopup: function () {
    var showForceSellLinkPopup = new Popup({
      selector: '.force-sell-link',
      sourceBlock: '.modal-content'
    });
    showForceSellLinkPopup.register();
  }
}));
